
import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "@/components/ui/button";
import { useAuthBypass } from "@/lib/auth";

const isAuthDisabled = true;

export const LoginButton = () => {
  const auth = isAuthDisabled ? useAuthBypass() : useAuth0();
  const { loginWithRedirect } = auth;

  return (
    <Button onClick={() => loginWithRedirect()}>
      Log In
    </Button>
  );
};
